const en = {
  lang: {
    zh: '中文',
    en: 'English'
  },
  menu: {
    home: 'Home',
    products: 'Products',
    solutions: 'Solutions',
    news: 'News',
    about: 'About Us',
    list: {
      aiPlatform: 'AI Fusion Platform',
      aiDeviceExpert: 'AI Device Expert Platform',
      aiDigitalHuman: 'AI Digital Human Platform',
      aiEdgeDevice: 'AI Edge Terminal',
      specialRobot: 'Special Robot',
      coalClaw: 'CoalClaw Assistant',
      coalMineVideo: 'Coal Mine Anti-Violation',
      mineAi: 'Mine Panorama AI',
      chemicalAi: 'Chemical AI Video',
      energyMaintenance: 'Energy Maintenance',
      powerGridInspection: 'Grid Inspection',
      aiQuality: 'AI Quality & Safety'
    }
  },
  common: {
    siteTitle: 'Shanghai RUANWO Intelligent Technology Co., Ltd.',
    contactUs: 'Contact Us',
    viewDetails: 'View Details',
    loading: 'Loading...',
    noNews: 'No News',
    companyMission: 'Mission',
    companyVision: 'Vision',
    companyValues: 'Values',
    companyIntro: 'Company Profile',
    teamHistory: 'Team History',
    certSystem: 'Certification',
    ipRights: 'IP Rights',
    serviceExp: 'Years of Experience',
    mineAlgorithm: 'Mine AI Algorithms',
    citiesCovered: 'Cities Covered',
    customerCases: 'Customer Cases',
    effect: 'Effect',
    evaluation: 'Evaluation'
  },
  footer: {
    contact: 'Contact Us',
    companyName: 'Shanghai Ruanwo Intelligent Technology Co., Ltd.',
    address: '9F, 2143 North Zhongshan Road, Putuo District, Shanghai',
    icp: 'ICP No. 2026037328-1'
  },
  sectionTitle: {
    coreProducts: 'Core Products',
    coreProductsSub: 'Focused on industrial intelligence scenarios, building a full-stack product system integrating industry LLMs, AI visual recognition, smart equipment and edge computing',
    solutions: 'Solutions',
    solutionsSub: 'Providing one-stop intelligent solutions covering AI vision, LLM applications, smart equipment and digital platforms for mining, energy, chemical, power grid, tobacco and intelligent manufacturing industries.',
    coreAbility: 'Core Capabilities',
    coreAbilitySub: '10+ years in coal and chemical industries, 100+ coal mine case studies',
    industryModel: 'Industry Models',
    customerCase: 'Customer Cases',
    productFeatures: 'Product Features',
    solutionFeatures: 'Solution Features',
    solutionArchitecture: 'Solution Architecture',
    solutionAdvantages: 'Solution Advantages'
  },
  home: {
    banner: {
      aiEngine: {
        title: 'AI Technology Engine',
        desc: 'Integrating AI vision, energy industry LLMs, voice recognition and intelligent data platform to build an AI engine for the energy sector',
        tags: ['Agent', 'Digital Human', 'Smart Equipment Robot']
      },
      energySolution: {
        title: 'Energy Industry AI Solution Provider',
        desc: 'Algorithm, hardware and LLM trinity, empowering energy industry digital transformation',
        tags: ['AI', 'Digitalization', 'Energy Brain']
      },
      digitalHuman: {
        title: 'AI Digital Human Platform',
        desc: 'A digital intelligence library for the coal mining industry, enabling every employee to access professional procedures and work standards through conversation',
        tags: ['Intelligent Q&A', 'Standard Library', 'Work Guidance']
      },
      edgeDevice: {
        title: 'AI Edge Computing Terminal',
        desc: 'Designed for the harshest coal mine environments, providing millisecond-level AI analysis at the underground frontline',
        tags: ['Explosion-proof', 'Edge Computing', 'Real-time Analysis']
      },
      drone: {
        title: 'Drone Tunnel Inspection',
        desc: 'Real-time image and point cloud capture, intelligent identification of cracks, deformation, leakage and other hazards to improve efficiency and reduce risks.',
        tags: ['Auto Inspection', 'Hazard Detection', '3D Modeling']
      }
    },
    products: {
      fusion: {
        title: 'AI Fusion Management Platform',
        desc: 'AI fusion management platform, data-driven model empowering industry scenarios to solve safety problems.'
      },
      deviceExpert: {
        title: 'AI Device Expert Platform',
        desc: 'AI Device Expert Platform, full lifecycle device monitoring, predictive maintenance, rapid fault diagnosis'
      },
      digitalHuman: {
        title: 'AI Digital Human Platform',
        desc: 'A digital intelligence library for the coal mining industry, enabling every employee to access professional procedures and work standards through conversation'
      },
      edgeDevice: {
        title: 'AI Edge Computing Terminal',
        desc: 'AI edge computing terminal, reliable and secure edge computing device, equipped with coal mine industry models, real-time analysis, localized closed-loop control.'
      },
      specialRobot: {
        title: 'Special Robot',
        desc: 'Hydraulic support auxiliary manipulator, human-robot collaboration for hole alignment and pin insertion, improving assembly efficiency and reducing operational risks.'
      },
      coalClaw: {
        title: 'CoalClaw Assistant',
        desc: 'CoalClaw coal mining private assistant, management assistant for quick access to business and production data.'
      }
    },
    solutions: {
      antiViolation: {
        title: 'Coal Mine Video Anti-Violation',
        desc: 'Through visual intelligent closed-loop management, significantly reduce manual operation risks and standardize operations'
      },
      mineMonitor: {
        title: 'Mine Panorama AI Monitoring',
        desc: 'Covering fully-mechanized face, belt transport, pump room, hoist room and other process intelligent monitoring'
      },
      chemicalMonitor: {
        title: 'Chemical AI Video Monitoring',
        desc: 'Dangerous area wearing detection, fire and smoke detection, dangerous cargo loading/unloading standardization monitoring'
      }
    },
    abilities: {
      llm: {
        title: 'Coal Industry LLM',
        desc: 'Deep learning of coal mine production and safety knowledge, understanding complex business logic, automatically analyzing risks and assisting decision support'
      },
      vision: {
        title: 'Full-scene AI Video Recognition',
        desc: 'Million-level coal mine industry dataset, 100+ industry scenario algorithms, industry-leading accuracy, millisecond response speed'
      },
      hardware: {
        title: 'Integrated Hardware & Software Delivery',
        desc: 'Algorithm deeply adapted to self-developed hardware, from all-in-one machines to dedicated sensors, achieving seamless collaboration between edge computing and on-site alarms'
      },
      lifecycle: {
        title: 'Full Lifecycle Service',
        desc: 'Providing one-stop closed-loop service from on-site survey, solution design, installation and commissioning to post-maintenance, truly solving deployment challenges'
      }
    },
    industry: {
      mainTransport: 'Main Transport',
      auxTransport: 'Auxiliary Transport',
      mining: 'Mining',
      tunneling: 'Tunneling',
      ventilation: 'Ventilation',
      others: 'Others',
      models: {
        mainTransport: {
          dynamicBelt: 'Dynamic Belt Area Detection',
          coalBunker: 'Coal Bunker Top Coal Accumulation',
          beltRider: 'Belt Rider Over-position Monitoring',
          largeCoal: 'Belt Large Coal Detection',
          foreignObject: 'Belt Foreign Object Detection',
          coalVolume: 'Belt Coal Volume Monitoring',
          beltDeviation: 'Belt Deviation Detection',
          boltDetection: 'Belt Bolt Detection'
        },
        auxTransport: {
          monkeyCar: 'Monkey Car with Oversized Materials',
          manCarGate: 'Man Car Static Gate Detection',
          leanManCar: 'Leaning on Man Car',
          overLoad: 'Material Car Overload Alarm',
          winchRoom: 'Winch Room Inspection Operation Detection',
          tunnelCount: 'Tunnel Track Personnel Count',
          rubberCarHead: 'Rubber Car Head Extension Detection',
          noRider: 'No Rider While Driving',
          mineCarRide: 'Mine Car Riding Detection',
          antiRunaway: 'Anti-runaway Device Status'
        },
        mining: {
          scraperAlign: 'Scraper Alignment Detection',
          chainBreak: 'Scraper Chain Break Monitoring',
          dangerZone: 'Dynamic Danger Zone Intrusion',
          rollerGuard: 'Roller and Guard Plate Status'
        },
        tunneling: {
          safetyRope: 'Tunneling Machine Safety Rope Detection',
          temporarySupport: 'Hydraulic Support Usage Detection',
          gasProbe: 'Methane Gas Probe Detection',
          safetyNet: 'Protection Net Switch Detection'
        },
        ventilation: {
          tunnelPerson: 'Tunnel Personnel Record',
          tunnelDeform: 'Tunnel Deformation Monitoring',
          damperSwitch: 'Damper Switch Status'
        },
        others: {
          onDuty: 'On-duty Detection',
          sleepDuty: 'Sleep-on-duty Detection',
          crowd: 'Crowd Detection',
          faceRecog: 'Face Recognition',
          keyRoom: 'Key Room Personnel Record',
          dangerZone: 'Danger Zone Intrusion',
          cameraCover: 'Camera Obstruction Detection',
          noHelmet: 'No Helmet Detection',
          waterLevel: 'Water Level Warning',
          highTemp: 'Equipment High Temperature Warning'
        }
      }
    },
    cases: {
      mineAiEye: {
        title: 'Mine AI "Eye"',
        desc: 'AI video fusion platform serves as the "smart brain" of the mine production command, starting from three core passages - tunnel, belt and air duct - gradually covering all mine systems. The 30+ intelligent algorithms built into the platform have become the most capable assistants for managers. When the belt conveyor is running, the algorithm can automatically identify abnormalities such as large coal gangue, belt deviation, coal accumulation; on the tunnel, overloaded material cars, personnel riding violations, and runway protection device failures cannot escape the AI "eye"; even details like damper status and personnel passing through fixed areas can be monitored in real time. "Previously, the safety department was too busy to keep up, now one or two people can easily handle it, saving time and effort, and work efficiency has increased several times."'
      },
      intelligentDispatch: {
        title: '"One Map" Intelligent Dispatch Center for a Large Production Mine',
        desc: 'The mine originally faced pain points such as data silos across systems and low manual inspection efficiency. By deploying the AI fusion management platform, it integrated more than 300 video points underground and used the AI engine to achieve real-time monitoring of personnel violation capture, belt foreign object detection, and equipment operating status. After the platform went live, the "cockpit" mode enabled one-map management of the entire mine, and the automatic discovery rate of safety hazards increased to over 98%. Safety officers were freed from massive monitoring, achieving a transformation from "passive viewing" to "active warning".'
      },
      predictiveMaintenance: {
        title: 'Predictive Maintenance Application for Main Transport System Core Drive',
        desc: 'In a long-distance belt transport system of a coal preparation plant, wireless temperature-vibration sensors were installed at key positions of motors and reducers, and connected to the AI device expert platform. The system used deep learning models to model historical operating data and successfully predicted fatigue damage of reducer bearings 72 hours in advance during a routine production. Compared with traditional regular shutdown maintenance, this solution reduced unplanned downtime by more than 40 hours and saved equipment maintenance costs and indirect production losses of over one million yuan.'
      },
      safetyAssistant: {
        title: 'Safety Procedure Intelligent Assistant for Mining Teams',
        desc: 'Addressing the inconvenience of safety technicians consulting safety measures and the long learning cycle for new procedures. The mine deployed the "WenMei" intelligent agent terminal in the dispatch room and pre-shift meeting area. Mining workers can quickly obtain professional knowledge such as "roof management at fully-mechanized faces" or "water exploration operation standards" through natural language dialogue. The case shows that the frequency of safety procedure retrieval by mine employees increased by 5 times, and the time for technicians to prepare construction measure documents was shortened by 70%, significantly consolidating the safety compliance foundation at production sites.'
      },
      edgeResponse: {
        title: 'Edge-side "Anti-violation" Millisecond Response Practice at Fully-mechanized Face',
        desc: 'At the fully-mechanized face of a high-gas mine, by deploying intrinsically safe underground intelligent explosion-proof terminals, AI algorithms were sunk to the production frontline. The terminal analyzes the coal cutter trajectory and personnel safety distance locally in real time. Once personnel are found to have illegally entered the spalling area, without uploading to the cloud, the terminal directly triggers sound and light alarms for voice warning on site. This solution solves the delay problem caused by insufficient underground bandwidth, controls the warning response speed within 200ms, and eliminates on-site violation hazards in the bud.'
      },
      unmannedInstallation: {
        title: 'Unmanned Exploration of Equipment Installation at Coal Mining Face under Complex Geological Conditions',
        desc: 'During the installation of a thin coal seam face, due to narrow space, manual adjustment of support posture had high risk and low precision. After introducing the hydraulic support auxiliary installation robot, its high-precision vision perception system automatically identifies the support center line, and the auxiliary arm accurately completes alignment, positioning and adjustment. Case results show that the installation efficiency per shift increased by 25%, and key high-risk areas achieved zero personnel entry, greatly reducing accident risks such as crushing and collision.'
      },
      officeAutomation: {
        title: 'Smart Mine Office Automation and Production Report Intelligent Generation System',
        desc: 'A mining group used Coalclaw private intelligent assistant to process massive production logs and dispatch records. Through the local LLM, the assistant automatically extracts key indicators such as daily coal cutting cycles, footage, and hazard inspection quantities from each mining area, and generates standardized daily production reports and weekly safety analysis reports with one click. In actual application, mine office workers were freed from mechanical data entry work, daily report processing time was reduced from 3 hours to 10 minutes, and data accuracy reached 100%, greatly improving management efficiency.'
      },
      antiViolationUpgrade: {
        title: 'Anti-violation Intelligent Upgrade for a 10 Million-ton Mine',
        desc: 'The mine originally relied on manual video inspection, with delayed identification of hazards such as illegal crossing at belt curves and single-person violation operations',
        effect: 'After deploying the solution, the system achieved all-day monitoring of mining faces and belt transport lines. The AI assistant automatically screens violation behaviors daily and pushes captured short videos to management mobile apps.',
        evaluation: 'Within three months of operation, on-site violation frequency decreased by 75%, and safety officers transformed from "massive searching" to "precise verification", significantly improving the mine\'s intrinsic safety level.'
      },
      fullScene: {
        title: 'Smart Mine Full-scene Perception System Construction',
        desc: 'Addressing the current situation of lengthy mine processes, scattered monitoring points, and serious information silos, aiming to build a full-domain intelligent monitoring network.',
        effect: 'The solution covers the full path from shaft entrance to fully-mechanized face. In the main transport section, AI successfully warned of large gangue accumulation multiple times, avoiding belt tear accidents; in the hoist room, AI inspection replaced traditional manual scheduling.',
        evaluation: 'Achieving a 30%+ reduction in key mine positions, production anomaly response time reduced from 10 minutes to within 30 seconds.'
      },
      chemicalPark: {
        title: 'Digital Safety Platform Construction for a Chemical Park',
        desc: 'Chemical equipment is densely packed in the park, involving flammable and explosive material storage. Traditional manual patrols are difficult to cover complex equipment blind spots.',
        effect: 'After the solution went live, algorithm coverage was applied to the loading area, accurately identifying serious violations such as personnel not grounding and smoking during loading multiple times.',
        evaluation: 'The solution helped the park build a defense mechanism of "automatic discovery, real-time alarm, and linked disposal", improving the accuracy of safety hazard detection to over 98%, greatly reducing safety risk pressure.'
      }
    }
  },
  about: {
    banner: {
      title: 'About Us',
      desc: 'Only build software that delivers real value'
    },
    mission: 'Provide real value to users through digital technology',
    vision: 'Commit to becoming the most professional intelligent solution provider',
    values: 'Customer-centric, achieving self-worth',
    intro: 'Shanghai Ruanwo Intelligent Technology Co., Ltd., founded in 2010, is a high-tech enterprise focused on "AI + Big Data" as the main axis, with "Intelligent IoT" and "Cybersecurity" as the two wings. We provide professional solutions including visual convergence media platforms, big data platforms, industrial automation, network and data security for clients. Headquartered in Shanghai, with business covering the whole country and branches in multiple provinces, we provide professional information construction products, services and solutions for clients in government, petroleum, mining, chemical, power grid, tobacco, automotive and other industries.',
    stat1: '15 Years',
    stat2: '100+',
    stat3: '20+',
    stat4: '100+'
  },
  news: {
    banner: {
      title: 'Company News',
      desc: 'Focus on industry frontiers, record enterprise growth, share technological achievements'
    },
    list: {
      item1: {
        title: 'Our AI Device Expert Platform Officially Launched, Empowering Smart Manufacturing Upgrade',
        desc: 'The platform achieves predictive maintenance through intelligent Agent and digital human technology, helping enterprises improve maintenance efficiency by 30%-50%, covering the full smart manufacturing scenario.'
      },
      item2: {
        title: 'Invited to Smart Manufacturing Summit, Sharing Intelligent O&M Solutions',
        desc: 'The company\'s technical team delivered a keynote speech at the summit, sharing core capabilities around device management, fault analysis, and intelligent diagnostics, receiving high industry recognition.'
      },
      item3: {
        title: 'New Software Copyrights Added, Technical Strength Receives Authority Certification',
        desc: 'The company has achieved multiple technical breakthroughs in intelligent device monitoring, automated data reporting, and AI fault diagnosis, successfully obtaining certification from the National Copyright Administration.'
      },
      item4: {
        title: 'Reached Cooperation with Multiple Manufacturing Enterprises, System Officially Deployed',
        desc: 'The company\'s device management platform has been successfully deployed in multiple manufacturing enterprises, achieving intelligent device management, real-time monitoring, automatic alerts and other functions.'
      }
    }
  },
  products: {
    cp001: {
      name: 'AI Fusion Management Platform',
      banner: {
        title: 'AI Fusion Management Platform',
        desc: 'Industrial safety guardian, achieving one-map monitoring and intelligent alarms'
      },
      features: {
        antiViolation: { title: 'Anti-Violation Detection', desc: '' },
        mainTransport: { title: 'Main/Auxiliary Transport Monitoring', desc: 'AI mining face monitoring' },
        scraper: { title: 'Scraper Abnormal Detection', desc: '' }
      }
    },
    cp002: {
      name: 'AI Device Expert Platform',
      banner: {
        title: 'AI Device Expert Platform',
        desc: 'AI Device Expert Platform, full lifecycle device monitoring, predictive maintenance, rapid fault diagnosis'
      },
      features: {
        management: { title: 'Device Management', desc: 'Intelligent device management cockpit' },
        analysis: { title: 'Fault Analysis', desc: 'Solidify expert experience into processes' },
        report: { title: 'Data Reports', desc: 'Auto-generate device daily reports, emergency reports, etc.' }
      }
    },
    cp003: {
      name: 'AI Digital Human Platform',
      banner: {
        title: 'AI Digital Human Platform',
        desc: 'A digital intelligence library for the coal mining industry, enabling every employee to access professional procedures and work standards through conversation.'
      },
      features: {
        regulation: { title: 'Regulation Second-level Retrieval', desc: 'Deep learning of "Coal Mine Safety Regulations" and various operation standards, supporting precise Q&A in natural language' },
        standard: { title: 'Standardized Work Guidance', desc: 'Push corresponding safety measures and standardized process suggestions anytime, anywhere' },
        multiSource: { title: 'Multi-source Support', desc: 'Text and language (including various dialects) can respond quickly' }
      }
    },
    cp004: {
      name: 'AI Edge Computing Terminal',
      banner: {
        title: 'AI Edge Computing Terminal',
        desc: 'AI edge computing terminal, reliable and secure edge computing device, equipped with coal mine industry models, real-time analysis, localized closed-loop control.'
      },
      features: {
        localCompute: { title: 'Local Computing Empowerment', desc: 'Intrinsically safe explosion-proof design, supporting independent operation of complex algorithms in offline or low bandwidth environments' },
        alarm: { title: 'Real-time Sound & Light Alarm', desc: 'Linked with algorithms, triggering on-site voice reminders at the first time when violations are detected' }
      }
    },
    cp005: {
      name: 'Special Robot',
      banner: {
        title: 'Special Robot',
        desc: 'For complex and high-risk coal mine operations, integrating robotics, intelligent perception and autonomous control capabilities, achieving replacement of personnel in dangerous operations, reduction in repetitive operations, and unmanned intelligent inspection, comprehensively improving mine safety production and intelligent operation levels.'
      },
      features: {
        robotReplace: { title: 'Robot Replacement for Dangerous Work', desc: 'For high-risk scenarios such as hydraulic support installation, equipment handling, and dangerous area operations, robots replace manual labor for heavy and dangerous operations, effectively reducing personnel safety risks and improving operational efficiency and quality.' },
        autoInspect: { title: 'Intelligent Inspection Autonomous Operation', desc: 'Supports autonomous inspection in underground tunnels, chamber machine rooms, substations, transport systems and other scenarios, achieving device status monitoring, instrument recognition, environment perception and anomaly detection, improving inspection coverage and real-time performance' },
        aiPerceive: { title: 'AI Perception and Collaborative Linkage', desc: 'Integrating visual recognition, environment perception, positioning navigation and wireless communication technologies, can collaborate with dispatch platforms, AI video systems, and device management systems to achieve anomaly alarms, remote control and intelligent decision support, creating a new model for intelligent mine O&M.' }
      }
    },
    cp006: {
      name: 'CoalClaw Assistant',
      banner: {
        title: 'CoalClaw Assistant',
        desc: 'CoalClaw coal mining private assistant, management assistant for quick access to business and production data.'
      },
      features: {
        docReport: { title: 'Document & Report Automation', desc: 'Automatically organize daily production reports and weekly safety reports, and support generating trend charts based on historical data' },
        taskManage: { title: 'Intelligent Task Supervision', desc: 'Automatically extract action items from meeting minutes and remind relevant responsible persons through the system for closed-loop processing' }
      }
    }
  },
  algorithm: {
    fa001: {
      name: 'Coal Mine Anti-Violation Solution',
      banner: {
        title: 'Coal Mine Anti-Violation Solution',
        desc: 'Integrating "Intelligent Vision Capture, Safety Knowledge Assistant, Closed-loop Management Process" to create an out-of-the-box AI safety supervision expert for mining enterprises'
      },
      features: {
        outOfBox: { title: 'Out-of-the-box Algorithm Library', desc: 'Pre-installed 100+ mature algorithms for coal mine regulations, including personnel gathering, violation crossing, post detection, no self-rescuer, ready for battle on launch' },
        knowledgeLink: { title: 'Knowledge Linkage Warning', desc: 'Deeply integrated with "WenMei" knowledge base, automatically displays corresponding "Safety Regulations" clauses when triggering violation capture, assisting on-site correction' },
        evidenceTrace: { title: 'Full Video Evidence Chain Tracing', desc: 'Automatically clips video segments after violations, establishing a standardized closed-loop management process of "capture-push-review-rectification"' },
        quickDeploy: { title: 'Integrated Software & Hardware Quick Deployment', desc: 'Adapted to explosion-proof edge terminals, supporting underground local real-time processing, ensuring alarm latency below 200ms in extreme environments' }
      },
      advantages: {
        authority: { title: 'Authoritative Compliance Empowerment', desc: 'Algorithm logic deeply benchmarks "Coal Mine Safety Regulations", ensuring every violation capture is evidence-based and meets regulatory requirements' },
        knowledgeAssist: { title: 'Knowledge-assisted Correction', desc: 'Industry pioneer linking AI vision with "WenMei" knowledge base, not only detecting violations but also informing employees of correct operation standards in real time' },
        zeroLeak: { title: '"Zero Leak" Safety Network', desc: 'Using high-precision visual models to overcome underground low-light interference, achieving all-time, no-blind-zone monitoring of key work and dangerous areas' }
      }
    },
    fa002: {
      name: 'Mine Full-scene AI Video Recognition Solution',
      banner: {
        title: 'Mine Full-scene AI Video Recognition Solution',
        desc: 'Covering fully-mechanized mining, main transport, auxiliary transport, power supply, hoisting and other processes, achieving full-dimensional digital perception of mines from surface to underground'
      },
      features: {
        faceMonitor: { title: 'Fully-mechanized Face Intelligent Monitoring', desc: 'Real-time monitoring of coal cutter position, scraper chain breakage, support posture and mining area personnel dynamics, ensuring standardized mining process execution' },
        transportProtect: { title: 'Main Transport System Protection', desc: 'Providing identification of foreign objects (bolts/large gangue), belt deviation, tear and coal accumulation monitoring across the entire belt transport line, linked with emergency stop alarms.' },
        unmannedRoom: { title: 'Fixed Chamber Unmanned Attendance', desc: 'For pump rooms, hoist rooms, and substations, achieving environmental anomaly monitoring, inspection path recording and abnormal temperature rise warnings, helping achieve reduced/unmanned attendance' },
        multiTerminal: { title: 'Full-scene Multi-terminal Linkage', desc: 'Video stream processed through intelligent data platform, simultaneously presenting full mine dynamics on dispatch room screens, PC and mobile terminals in real time.' }
      },
      advantages: {
        fullCoverage: { title: 'Full Mine Scene Coverage', desc: 'Covering all business scenarios including mining, main transport, auxiliary transport, power supply and hoisting, achieving full-domain video intelligent perception above and below ground' },
        aiWarning: { title: 'AI Recognition Proactive Warning', desc: 'Based on AI visual recognition technology, achieving real-time warning and precise identification of multiple types of violations and risk hazards' },
        closedLoop: { title: 'Multi-terminal Linkage Closed-loop Management', desc: 'Breaking the "identification-alarm-disposal" full-process closed-loop management, promoting digital and intelligent upgrade of mine safety governance' }
      }
    },
    fa003: {
      name: 'Chemical Industry Intelligent Supervision Solution',
      banner: {
        title: 'Chemical Industry Intelligent Supervision Solution',
        desc: 'With AI video detection as the core, building a four-in-one safety protection network of "Person, Object, Environment, Management"'
      },
      features: {
        wearDetect: { title: 'Dangerous Area Standard Wear Detection', desc: 'Real-time identification of whether workers are wearing protective clothing, anti-static shoes, positive-pressure air respirators and other specific protective equipment.' },
        fireWarning: { title: 'Fire & Smoke Millisecond Warning', desc: 'For open spaces such as tank farms and pipe galleries, AI algorithms capture fire in the initial stage, response speed several times faster than traditional temperature/smoke sensors.' },
        loadingDetect: { title: 'Loading/Unloading Compliance Supervision', desc: 'For hazardous chemical loading/unloading areas, automatically identify crane pipe position, static grounding alarms, violations during loading/unloading and personnel absence.' },
        intrusionDetect: { title: 'Perimeter Intrusion and Violation Stay', desc: '24-hour electronic fence monitoring of device areas and fire-prohibited areas, automatically identify high-risk behaviors such as climbing, unauthorized phone use, and smoking.' }
      },
      advantages: {
        proactive: { title: 'Proactive Warning', desc: 'AI real-time identification of fire, smoke, violations and safety hazards, achieving proactive risk discovery and rapid warning' },
        fullMonitor: { title: 'Full-domain Supervision', desc: 'Covering personnel, equipment, environment and operation processes, creating an integrated "Person, Object, Environment, Management" safety supervision system.' },
        linked: { title: 'Linked Closed-loop', desc: 'Achieving closed-loop management of alarms, disposal, review and tracing, comprehensively improving the intrinsic safety level of chemical enterprises' }
      }
    }
  },
  details: {
    WenMei: {
      banner: {
        title: 'AI Device Expert Platform',
        desc: 'Predictive maintenance system, maintenance efficiency improved by 30%-50%'
      },
      list: {
        item1: { title: 'Device Management', desc: 'Intelligent device management cockpit' },
        item2: { title: 'Fault Analysis', desc: 'Solidify expert experience into processes' },
        item3: { title: 'Data Reports', desc: 'Auto-generate device daily reports, emergency reports, etc.' }
      }
    },
    YiMei: {
      banner: {
        title: 'AI Device Expert Platform',
        desc: 'Predictive maintenance system, maintenance efficiency improved by 30%-50%'
      },
      list: {}
    }
  }
}

export default en